export default "__VITE_ASSET__bfgqxUOk__"